import { AdaptiveTestWorkflowType } from "constants/exam-constants";
import { useQueryParam } from "hooks/useQueryParam";
import { AdaptiveTestPage, MixedTopicPracticePage } from "pages/StudentEnvironment";

export const AdaptiveTestPageRenderer = (): JSX.Element => {
  const workflow = useQueryParam("workflow");

  if (workflow === AdaptiveTestWorkflowType.MIXED) {
    return <MixedTopicPracticePage />;
  }

  return <AdaptiveTestPage />;
};
